var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Card", {
        scopedSlots: _vm._u([
          {
            key: "head",
            fn: function () {
              return [
                _c("h5", [
                  _vm._v("\n                Journal Section "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        color: "red",
                        "font-size": "16px",
                        margin: "0",
                      },
                    },
                    [_vm._v("*")]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "main",
            fn: function () {
              return [
                _c("form", { attrs: { action: "" } }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("h6", [
                      _vm._v(
                        "Select the appropriate section for this submission (See Sections and Policies in "
                      ),
                      _c("a", { attrs: { href: "#" } }, [
                        _vm._v("About the Journal"),
                      ]),
                      _vm._v(")."),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          { staticClass: "asterik", attrs: { for: "" } },
                          [_vm._v("Primary Section/E-Collection/Theme Issue")]
                        ),
                        _vm._v(" "),
                        _c("jselect", {
                          attrs: {
                            options: _vm.sections,
                            "default-option": true,
                            label: "section",
                            "label-key": "title",
                            "value-key": "section_id",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", {}, [
                          _c("a", { attrs: { href: "#" } }, [
                            _vm._v(
                              "View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]"
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v("Section Policy")]),
                          _vm._v(" "),
                          _c("p", [_vm._v("This is some placeholder text.")]),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v("Secondary Section(s)/Theme(s)"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        { staticClass: "form-control dropdown" },
                        [
                          _c("option", [_vm._v("Please Choose")]),
                          _vm._v(" "),
                          _vm._l(_vm.sections, function (section) {
                            return _c(
                              "option",
                              { domProps: { value: section.section_id } },
                              [_vm._v(_vm._s(section.title))]
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("div", {}, [
                        _c("a", { attrs: { href: "#" } }, [
                          _vm._v(
                            "View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-info-circle" }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("a", { attrs: { href: "#" } }, [
                          _vm._v(
                            "View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-info-circle" }),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("a", { attrs: { href: "#" } }, [
                          _vm._v(
                            "View E-collection: Canada Health Infoway e-Collection Benefits Evaluation [Section Id: 817]"
                          ),
                        ]),
                        _vm._v(" "),
                        _c("i", { staticClass: "fas fa-info-circle" }),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }